import { z } from "zod";

export const createRuleResponseItemSchema = z
  .object({
    uuid: z.uuid(),
    name: z.string(),
    vehicleCount: z.int(),
    error: z.string().nullable().optional(),
    date: z.string(),
  })
  .strict();

export const createRuleResponseSchema = z.array(createRuleResponseItemSchema);

export type CreateRuleResponseItem = z.infer<
  typeof createRuleResponseItemSchema
>;
export type CreateRuleResponse = z.infer<typeof createRuleResponseSchema>;
